<template>
  <div class="insallment-body w-100">
    <div class="px-4">
      <ListHeader
        :profile="customerProfile"
        :lineProfile="lineProfile"
        class="mt-4"
      />
      <div
        v-if="!isVerify || !isHaveContract"
        class="px-4 py-5 mt-2 text-center verify-body justify-content-center d-flex"
      >
        <div>
          <div v-if="!customerProfile.idCard">
            <p class="mt-4 f-orange font-weight-bold">
              ไม่พบข้อมูลการลงทะเบียนของท่าน
            </p>
            <p class="mt-1 f-orange font-weight-bold">
              กรุณาลงทะเบียนก่อนเข้าใช้งาน
            </p>
            <!-- <router-link :to="'/register'">
              <b-button
                variant="submit"
                class="btn-submit w-100 mt-4"
                @click="$router.push({ path: '/register', replace: true })"
                >ลงทะเบียน</b-button
              >
            </router-link> -->
          </div>
          <div v-else-if="!isHaveContract">
            <div class="mt-4 f-orange font-weight-bold">
              ยังไม่พบข้อมูลสัญญาสินเชื่อของท่านในขณะนี้
            </div>
            <div class="mt-4 f-orange font-weight-bold">
              หากมีข้อสงสัยโทร
              <a
                ><span
                  v-for="(c, i) in '1317'"
                  :key="i"
                  class="link-tel"
                  :class="[{ 'link-tel-green': c == '3' }, 'link-tel']"
                  >{{ c }}<span class="link-tel-green"></span></span
              ></a>
            </div>
          </div>

          <div v-else>
            <div v-if="!otpState.prefix">
              <div class="mt-4 f-orange font-weight-bold">
                พบข้อมูลสัญญาสินเชื่อของท่าน
              </div>
              <div>
                <b-button
                  class="mx-1 btn-submit w-100 px-3 mt-5"
                  ref="tabButton"
                  @click="sendOTP()"
                  >ยืนยันตัวตน</b-button
                >
              </div>
            </div>
            <div v-else>
              <FormOTP
                id="put-OTP"
                v-model="otpNumber"
                placeholder="ํOTP"
                type="number"
                pattern="\d*"
                inputmode="numeric"
                :isError="otpState.isError"
                :MobileNumber="customerProfile.mobileNumber"
                :prefix="otpState.prefix"
                @sendOTPAgain="sendOTP"
              />
              <div id="otp-error" class="text-center mt-3 f-14 w-100">
                <font color="red">{{ otpState.otpMessage }}</font>
              </div>

              <b-button
                id="submit-OTP"
                variant="submit"
                class="btn-submit w-100 mt-4"
                @click="submitOTP"
                :disabled="otpState.waiting"
                >ยืนยัน</b-button
              >
            </div>
          </div>
          <p class="txt-tel mt-5">
            สอบถามข้อมูลเพิ่มเติมโทร.
            <a :href="`tel:${callCenter}`"
              ><span
                v-for="(c, i) in callCenter"
                :key="i"
                class="link-tel"
                :class="[{ 'link-tel-green': c == '3' }, 'link-tel']"
                >{{ c }}<span class="link-tel-green"></span></span
            ></a>
          </p>
        </div>
      </div>
      <div v-else>
        <div>
          <p class="mt-2 f-16 font-weight-bold">สัญญาสินเชื่อของท่าน</p>

          <div
            class="scroll-container d-flex flex-nowrap mt-2"
            ref="scrollContainer"
            @scroll="onScroll"
          >
            <div
              class="card card-slide p-sm-3 p-2 mr-2 d-flex align-items-start w-100"
              ref="contractList"
              v-for="(contract, index) in contractList"
              :key="index"
              :class="{ 'active-card': currentIndex === index }"
              @click="selectContract(contract, index, true)"
            >
              <b-row class="justify-content-between w-100 mx-0 my-auto">
                <b-col cols="7" class="my-auto">
                  <!-- Contract Details -->
                  <p class="f-14">
                    ประเภทสัญญา : {{ contractTypeText[contract.contractType] }}
                  </p>
                  <p class="f-14">
                    เลขที่สัญญา : {{ contract.contractNoDisplay }}
                  </p>
                  <p
                    class="f-14"
                    v-if="
                      contract.contractType !== 'SC' &&
                      contract.contractType !== 'PL' &&
                      contract.contractType !== 'TL'
                    "
                  >
                    {{ contract.modelName }}
                  </p>
                  <p
                    class="f-14 text-wrap"
                    v-if="
                      contract.contractType !== 'SC' &&
                      contract.contractType !== 'PL' &&
                      contract.contractType !== 'TL'
                    "
                  >
                    รุ่นรถ : {{ contract.model }}
                  </p>
                </b-col>
                <b-col cols="5" class="d-flex justify-content-center my-auto">
                  <!-- Contract Image -->
                  <img
                    v-if="contract.photo"
                    class="img-size"
                    :src="contract.photo"
                    alt="Product Image"
                  />
                </b-col>
              </b-row>
            </div>
          </div>

          <div class="indicator-container d-flex justify-content-center">
            <span
              v-for="(contract, index) in contractList"
              :key="index"
              :class="[
                'indicator-dot',
                { 'active-dot': currentIndex === index }
              ]"
              @click="scrollToIndex(index)"
            >
            </span>
          </div>
        </div>
        <div class="submenu-tap d-flex py-2 mt-2 justify-content-md-center">
          <b-button
            v-for="(item, index) in subMenu1"
            :disabled="
              currentContract.contractType == 'SC' && index !== 0 && index !== 6
            "
            :key="index"
            class="f-12 submenu1-class p-1 mx-1"
            :class="{
              'btn-green': tabIndex === item.tabIndex,
              'btn-white': tabIndex !== item.tabIndex
            }"
            ref="tabButton"
            @click="selectTap(item.tabIndex)"
            >{{ item.text }}
          </b-button>
        </div>
        <div id="content-installment">
          <b-card class="content-tab">
            <div v-if="tabIndex == '0'" class="px-3">
              <ContractDetail
                ref="contractDetail"
                :profile="profile"
                :lineProfile="lineProfile"
                :contract="currentContract"
              ></ContractDetail>
            </div>
            <div v-else-if="tabIndex == '1'">
              <InstallmentDetail
                ref="installmentDetail"
                :profile="profile"
                :contract="currentContract"
                :lineProfile="lineProfile"
                :displayContract="currentContract.contractNoDisplay"
              ></InstallmentDetail>
            </div>
            <div
              v-else-if="tabIndex == '2'"
              class="d-flex flex-column justify-content-between text-center align-items-center family-container my-3"
            >
              <img
                src="../../assets/images/SKL/SKL Family Club.png"
                width="120"
                height="auto"
              />
              <div class="f-14 f-orange mt-2">
                SKL แฟมิลี่คลับ : บริการสะสมคะแนน SKL Point <br />
                จากยอดชำระเงินค่างวด* เพื่อแลกรับสิทธิประโยชน์ และของที่ระลึก
                <br />
                500 บาท = 1 คะแนน
              </div>
              <div>
                <b-button
                  class="btn-green w-100 px-5 f-14 mt-2"
                  id="submit-register "
                  @click="openFamilyClub(1)"
                  :disabled="buttonLoading"
                  >เช็กคะแนนและแลกรับสิทธิพิเศษ</b-button
                >
              </div>
            </div>
            <div v-else-if="tabIndex == '3'">
              <InstallmentHistory
                ref="installmentHistory"
                :contractNo="contractNo"
                :lineProfile="lineProfile"
              ></InstallmentHistory>
            </div>
            <div v-else-if="tabIndex == '4'">
              <div class="justify-content-end d-flex f-14">
                <p class="f-medium">เลขที่สัญญา : {{ profile.contractNo }}</p>
              </div>
              <b-table
                striped
                hover
                :items="items"
                :fields="fields"
                :busy="isBusy"
                show-empty
                empty-text="ไม่พบข้อมูล"
                class="greenColor mt-sm-3 mt-2"
              >
              </b-table>
              <p class="mb-0 f-12 f-orange text-end">
                ข้อมูล ณ วันที่ {{ profile.asOfDate || "-" }} <br />
              </p>
              <div class="display-inline w-100">
                <span class="txt-note"
                  >หมายเหตุ : ข้อมูลที่แสดงในตารางเป็นข้อมูลค่างวดย้อนหลัง 3
                  เดือน และข้อมูลค่างวดล่วงหน้า 3 เดือน</span
                >
              </div>
            </div>
            <div v-else-if="tabIndex == '5'">
              <PaymentInvoice
                ref="paymentInvoice"
                :contractNo="contractNo"
                :lineProfile="lineProfile"
                :displayContract="currentContract.contractNoDisplay"
              ></PaymentInvoice>
            </div>
            <div v-else-if="tabIndex == '6'">
              <EReceiptList
                ref="EReceiptList"
                :contractNo="contractNo"
                :lineProfile="lineProfile"
                :displayContract="currentContract.contractNoDisplay"
              ></EReceiptList>
            </div>
          </b-card>
          <div
            v-if="currentContract.contractType !== 'SC'"
            class="d-flex w-100 justify-content-center"
          >
            <b-button
              ref="buttonBarcode"
              class="rounded-pill w-50 f-12 mr-2 mx-0 my-0 mt-2"
              @click="openQrcode()"
              :class="{ 'btn-green w-50': openQr, 'btn-white w-50': !openQr }"
              :disabled="
                buttonLoading ||
                qrButtonLoading ||
                this.currentContract.collectionStatusUnits == 'C'
              "
              >สร้างบาร์โคด/คิวอาร์โคด</b-button
            >

            <b-button
              @click="handleOpenPayment()"
              :class="{
                'btn-green w-50': openPayment,
                'btn-white w-50': !openPayment
              }"
              class="rounded-pill w-50 f-12 m-0 mt-2"
              :disabled="
                buttonLoading ||
                paymentButtonLoading ||
                this.currentContract.collectionStatusUnits == 'C'
              "
              >ชำระเงินออนไลน์</b-button
            >
          </div>
          <div v-else class="d-flex w-100 justify-content-center">
            <b-button
              @click="downloadSKL()"
              class="rounded-pill w-50 f-12 m-0 mt-2 btn-white w-100 f-green"
              :disabled="buttonLoading"
              >ดาวน์โหลด SKL โมบายแอปพลิเคชัน</b-button
            >
          </div>
          <b-collapse id="collapseQr" ref="collapseQr">
            <b-card class="mt-2 barcode-card">
              <QRcode
                ref="qrCode"
                :profile="profile"
                :contract="currentContract"
                :lineProfile="lineProfile"
              ></QRcode>
            </b-card>
          </b-collapse>
          <b-collapse id="collapsePayment" ref="collapsePayment">
            <b-card class="mt-2 payment-card">
              <OnlinePayment
                ref="onlinePayment"
                :idCard="customerProfile.idCard"
                :contract="currentContract"
                :lineProfile="lineProfile"
              ></OnlinePayment>
            </b-card>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InstallmentHistory from "./components/InstallmentHistory.vue";
import ListHeader from "./ListHeader";
import PaymentInvoice from "./components/PaymentInvoice.vue";
import InstallmentDetail from "./components/InstallmentDetail.vue";
import QRcode from "./components/QRcode.vue";
import ContractDetail from "./components/ContractDetail.vue";
import OnlinePayment from "./components/OnlinePayment.vue";
import EReceiptList from "./components/EReceiptList.vue";
const FormOTP = () => import("@/components/panels/formOTP");

export default {
  components: {
    ListHeader,
    InstallmentHistory,
    FormOTP,
    PaymentInvoice,
    InstallmentDetail,
    QRcode,
    ContractDetail,
    OnlinePayment,
    EReceiptList
  },
  data: () => {
    return {
      contractNo: "",
      lineId: "",
      lineProfile: {},
      profile: {
        asOfDate: "",
        contractNo: "",
        identificationNo: "",
        customerName: "",
        photo: ""
      },
      callCenter: "1317",
      isBusy: false,
      items: [],
      tabIndex: "0",
      otpNumber: "",
      fields: [
        {
          key: "term_No",
          label: "งวดที่",
          class: "text-center align-middle"
        },

        {
          key: "due_Date",
          label: "กำหนดชำระ",
          class: "text-center align-middle"
        },
        {
          key: "inst_Tot_Amt_String",
          label: "ค่างวด (บาท)",
          thClass: "text-center align-middle",
          tdClass: "text-end"
        },
        {
          key: "act_Tot_Amt_String",
          label: "ยอดเงินที่ต้องชำระ (บาท)",
          thClass: "text-center align-middle",
          tdClass: "text-end"
        }
      ],
      slides: [
        { title: "Slide 1", image: "https://via.placeholder.com/800x400" },
        { title: "Slide 2", image: "https://via.placeholder.com/800x400" },
        { title: "Slide 3", image: "https://via.placeholder.com/800x400" }
      ],
      subMenu1: [
        { text: "ข้อมูลสัญญา", tabIndex: "0" },
        { text: "ข้อมูลค่างวด", tabIndex: "1" },
        { text: "แฟมิลี่คลับ", tabIndex: "2" },
        { text: "ประวัติชำระ", tabIndex: "3" },
        { text: "ตารางค่างวด", tabIndex: "4" },
        { text: "ใบแจ้งชำระ", tabIndex: "5" },
        { text: "ใบเสร็จชำระเงิน/ใบกำกับภาษี", tabIndex: "6" }
      ],
      isHaveContract: false,
      isVerify: false,
      customerProfile: {},
      otpState: {
        isError: false,
        otpMessage: "",
        prefix: "",
        waiting: false
      },
      buttonLoading: false,
      firstContractNo: "",
      contractList: [],
      currentIndex: 0,
      currentContract: {
        contractNoDisplay: "",
        contractNo: "",
        model: "",
        modelName: null,
        licenceNo: "",
        customerName: "",
        collectionStatusUnits: "",
        photo: "",
        contractType: "",
        asofDate: ""
      },
      contractTypeText: {
        HP: "สินเชื่อเช่าซื้อ",
        FL: "สินเชื่อลีสซิ่ง",
        TL: "สินเชื่อรถเติมสุข",
        PL: "สินเชื่อเติมฝัน",
        SC: "SKL Card"
      },
      openQr: false,
      openPayment: false,
      paymentButtonLoading: false,
      qrButtonLoading: false,
      scrollDebounceTimer: null,
      firstLoad: true,
      macthContract: false,
      receiptData: {
        contractNo: "",
        typeCode: "",
        monthCode: "",
        yearCode: ""
      }
    };
  },
  beforeCreate() {
    this.tabIndex = this.$route.params.id;

    let liffId = "";
    if (this.tabIndex == 6) {
      liffId = this.$liff_ID_Ereceipt;
    } else {
      liffId = this.$liff_ID_InstallmentList;
    }

    this.$liff
      .init({ liffId: liffId })
      .then(() => {
        if (!this.$liff.isLoggedIn()) {
          this.$liff.login().then(() => {
            this.$liff.getProfile().then(profile => {
              this.lineProfile = profile;

              this.checkTerm(profile.userId);
              if (liffId == this.$liff_ID_Ereceipt) {
                this.getReceiptByNoti();
              }
              this.getCustomerProfile();

              // this.checkConsent();
            });
          });
        } else {
          this.$liff.getProfile().then(profile => {
            this.lineProfile = profile;
            this.checkTerm(profile.userId);
            if (liffId == this.$liff_ID_Ereceipt) {
              this.getReceiptByNoti();
            }
            this.getCustomerProfile();

            // this.checkConsent();
          });
        }
        this.$liff.getFriendship().then(data => {
          if (!data.friendFlag) {
            this.$liff.openWindow({
              url: `https://line.me/R/ti/p/${this.$liff_Channel_ID}`,
              external: false
            });
            this.$liff.closeWindow();
          }
        });
      })
      .catch(error => {
        console.error(error);
      });
  },
  created() {
    this.$isLoadingAlpha = true;
    document.body.classList.add("bg-body");
    this.updateTitle();
  },
  mounted() {
    document.body.classList.add("bg-body");
  },

  methods: {
    async sendReport() {
      if (!this.$route.query.linerichid) {
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$API_KEY_DEV_LINE_SKL);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        LineId: this.lineProfile.userId,
        LineRichId: this.$route.query.linerichid || "0",
        LineRichActionId: this.$route.query.linerichactiontid || "0",
        Sort: this.$route.query.sort || "0"
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch(`${this.$API_DEV_LINE_SKL}/ReportRichMenu`, requestOptions)
        .then(response => response.json())
        .then(result => {});
    },
    checkTerm(lineId) {
      let myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$API_KEY_DEV_LINE_SKL);
      myHeaders.append("Content-Type", "application/json");
      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
      };
      fetch(
        `${this.$API_DEV_LINE_SKL}/customer/checkterms/${lineId}`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            if (!result.detail) {
              // let routeData = this.$router.resolve({
              //   name: "policy",
              //   query: { lineid: lineId }
              // });
              // window.open(routeData.href, "_blank");
              this.$router.push({
                path: "/policy"
              });
            }
          } else {
            // let routeData = this.$router.resolve({
            //   name: "policy",
            //   query: { lineid: lineId }
            // });
            // window.open(routeData.href, "_blank");
            this.$router.push({
              path: "/policy"
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    CheckContract() {
      var requestOptions = {
        method: "GET",
        redirect: "follow",
        headers: {
          "api-key": this.$API_KEY_DEV_LINE_SKL
        }
      };

      fetch(
        `${this.$API_DEV_LINE_SKL}/customer/CheckContract/${this.lineProfile.userId}`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            this.isHaveContract = result.detail.isHaveContract;
            // ไม่มีสัญญาสินเชื่อเลย -> ส่งไปหน้าลงทะเบียน/ตรวจสอบข้อมูล
            // มีสัญญาแล้ว -> อยู่หน้านี้ต่อเพื่อให้กดยืนยันตัวตน (OTP)
            if (!this.isVerify && !this.isHaveContract) {
              if (this.macthContract) {
                this.$router.push({
                  path: `/register`,
                  query: { ...this.$route.query }
                });
              } else {
                this.$router.push("/register");
              }
            }
          }
        })
        .catch(error => console.log("error", error));
    },
    async selectContract(selectContract, index, isHidePayment, isReceipt) {
      this.$isLoadingAlpha = true;
      await this.getInstallmentList(selectContract, index, isReceipt);
      const tab = this.$refs.contractList[index];
      if (isHidePayment) {
        this.openQr = false;
        this.$refs.collapseQr.show = false;
        this.openPayment = false;
        this.$refs.collapsePayment.show = false;
      }

      this.$isLoadingAlpha = false;

      this.currentContract = selectContract;

      if (tab) {
        tab.scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        });
      }
    },
    async getInstallmentList(selectContract, selectTab, isReceipt) {
      if (selectContract) {
        this.contractNo = selectContract.contractNo;
        this.currentContract = selectContract;
        if (this.$refs.EReceiptList) {
          this.$refs.EReceiptList.filter = {
            TypeCode: "",
            YearCode: "",
            MonthCode: ""
          };
        }
      } else {
        this.contractNo = this.currentContract.contractNo;
      }

      this.tabIndex = this.$route.params.id;

      if (this.currentContract.contractType !== "SC") {
        await this.$nextTick();
        if (this.tabIndex == "0") {
          await this.$refs.contractDetail.getContractDetail(this.contractNo);
        } else if (this.tabIndex == "1") {
          await this.$refs.installmentDetail.getContratctInstallmentDetail(
            this.contractNo
          );
        } else if (this.tabIndex == "2") {
          await this.openFamilyClub(1);
        } else if (this.tabIndex == "3") {
          await this.$refs.installmentHistory.getPaymentHistoryList();
        } else if (this.tabIndex == "4") {
          await this.getInstalmentTable();
        } else if (this.tabIndex == "5") {
          await this.$refs.paymentInvoice.getInvoiceList();
        } else if (this.tabIndex == "6") {
          await this.$refs.EReceiptList.getFilter();
        }
      } else {
        if (this.$route.params.id !== "0" && this.$route.params.id !== "6") {
          this.$router.push(`/installment/0`);
          this.tabIndex = "0";
        } else if (this.tabIndex == "6") {
          this.$nextTick(() => {
            this.$refs.EReceiptList.getFilter();
          });
        }

        // this.$refs.contractDetail.getContractDetail(this.contractNo);
      }

      if (!selectTab) {
        this.$refs.qrCode.selectedPayment = "";
        this.$refs.onlinePayment.selectedPayment = "";
      }
      this.$isLoadingAlpha = false;
    },
    async getContractList() {
      this.$isLoadingAlpha = true;

      var requestOptions = {
        method: "GET",
        redirect: "follow",
        headers: {
          "api-key": this.$API_KEY_DEV_LINE_SKL
        }
      };

      await fetch(
        `${this.$API_DEV_LINE_SKL}/Contract/ContractList/${this.lineProfile.userId}`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            this.contractList = result.detail;
            if (this.$route.query.contractNo) {
              let index = result.detail.findIndex(
                x => x.contractNo == this.$route.query.contractNo
              );
              if (index == -1) {
                this.macthContract = false;
                this.currentContract = this.contractList[0];
                this.getInstallmentList();
                return;
              }
              this.macthContract = true;
              this.selectContract(this.contractList[index], index);
              this.currentContract = this.contractList[index];

              this.contractNo = this.$route.query.contractNo;

              if (this.$route.query.payment == "qr-code") {
                this.openQrcode();
              } else if (this.$route.query.payment == "online-payment") {
                this.handleOpenPayment();
              }
            } else if (this.receiptData?.contractNo) {
              let index = result.detail.findIndex(
                x => x.contractNo == this.receiptData.contractNo
              );
              if (index == -1) {
                this.macthContract = false;
                this.currentContract = this.contractList[0];

                this.getInstallmentList();
                return;
              }

              this.macthContract = true;

              this.selectContract(this.contractList[index], index, false, true);
              this.currentContract = this.contractList[index];

              this.contractNo = this.$route.query.contractNo;
              this.$nextTick(() => {
                const ref = this.$refs.EReceiptList;
                if (ref) {
                  Object.assign(ref.filter, {
                    TypeCode: 1 || "",
                    YearCode: this.$route.query.filterYear || "",
                    MonthCode: this.$route.query.filterMonth || "",
                    LineId: this.lineProfile.userId,
                    ContractNo: this.receiptData.contractNo
                  });
                  ref.getList?.();
                }
              });
            } else {
              this.currentContract = this.contractList[0];
            }

            this.getInstallmentList();
          }
        })
        .catch(error => {
          this.isBusy = false;
          this.items = [];
          console.error(error);
        });

      this.$isLoadingAlpha = false;
    },
    async getInstalmentTable() {
      this.isBusy = true;
      var myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$API_KEY_DEV_LINE_SKL);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        LineId: this.lineProfile.userId,
        ContractNo: this.currentContract.contractNo
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      await fetch(
        `${this.$API_DEV_LINE_SKL}/contract/paymentinstallment`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            this.items = result.detail.detail;
            this.profile.asOfDate = result.detail.asOfDate;
            this.profile.contractNo = result.detail.contractNo;
            this.profile.customerName = result.detail.customerName;
            this.callCenter = result.detail.callCenter;
            this.profile.photo = result.detail.photo;
            this.isBusy = false;
          }
        })
        .catch(error => {
          this.isBusy = false;
          // this.items = [];
          console.error(error);
        });
    },
    selectTap(index) {
      this.tabIndex = index;
      if (this.macthContract) {
        this.$router.push({
          path: `/installment/${index}`,
          query: { ...this.$route.query }
        });
      } else {
        this.$router.push(`/installment/${index}`);
      }

      this.openQr = false;
      this.$refs.collapseQr.show = false;
      this.openPayment = false;
      this.$refs.collapsePayment.show = false;
      const button = this.$refs.tabButton[index];
      if (button) {
        button.scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        });
      }
      this.getInstallmentList(null, 1);
    },
    async getCustomerProfile() {
      var requestOptions = {
        method: "GET",
        redirect: "follow",
        headers: {
          "api-key": this.$API_KEY_DEV_LINE_SKL
        }
      };

      await fetch(
        `${this.$API_DEV_LINE_SKL}/customer/profile/${this.lineProfile.userId}`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            this.isVerify = result.detail.profile.isVerify;
            this.customerProfile = result.detail.profile;
            this.$emit("event-from-installment", this.lineProfile.userId);
            if (!this.isVerify) {
              this.CheckContract();
            } else {
              this.isHaveContract = true;
              this.sendReport();
              this.getContractList();
            }
          } else {
            if (this.macthContract) {
              this.$router.push({
                path: `/register`,
                query: { ...this.$route.query }
              });
            } else this.$router.push("/register");
          }
          this.$isLoadingAlpha = false;
        })
        .catch(error => console.log("error", error));
    },
    sendOTP() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        MobileNumber: `66${this.customerProfile.mobileNumber.slice(1)}`,
        LineId: this.lineProfile.userId,
        IdCard: this.customerProfile.IDCard
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };
      fetch(`${this.$API_DEV_LINE_SKL}/OTP`, requestOptions)
        .then(response => response.json())
        .then(result => {
          this.otpState.prefix = result.detail.result;
        })
        .catch(error => {
          console.error(error);
        });
    },
    submitOTP() {
      this.buttonLoading = true;
      this.otpState.waiting = true;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        MobileNumber: `66${this.customerProfile.mobileNumber.slice(1)}`,
        OTP: this.otpNumber,
        LineId: this.lineProfile.userId,
        IdCard: this.customerProfile.IDCard
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };
      fetch(`${this.$API_DEV_LINE_SKL}/ValidateOTP`, requestOptions)
        .then(response => response.json())
        .then(result => {
          this.otpState.waiting = false;

          if (result.result == 1) {
            this.getCustomerProfile();
            this.buttonLoading = false;
          } else {
            this.otpState.isError = true;
            this.otpState.otpMessage = result.message;
            this.buttonLoading = false;
          }
        })
        .catch(error => {
          this.otpState.waiting = false;
          console.error(error);
          this.buttonLoading = false;
          this.$bvModal.show("modal-tryagain");
        });
    },
    async openFamilyClub(isClick) {
      this.buttonLoading = true;
      var requestOptions = {
        method: "GET",
        redirect: "follow",
        headers: {
          "api-key": this.$API_KEY_DEV_LINE_SKL
        }
      };
      this.$isLoadingAlpha = true;
      await fetch(
        `${this.$API_DEV_LINE_SKL}/customer/loginfamilyclub/${this.lineProfile.userId}`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            this.$family_club = result.detail.url;
            window.open(this.$family_club, "_blank");
          }

          this.buttonLoading = false;
        })
        .catch(error => console.log("error", error));
      this.$isLoadingAlpha = false;
    },

    onScroll() {
      clearTimeout(this.scrollDebounceTimer);
      this.scrollDebounceTimer = setTimeout(() => {
        const scrollLeft = this.$refs.scrollContainer.scrollLeft;
        const cardWidth = this.$refs.contractList[0].clientWidth;
        this.currentIndex = Math.round(scrollLeft / cardWidth);
      }, 150);
    },
    scrollToIndex(index) {
      const cardWidth = this.$refs.contractList[index].clientWidth;
      this.$refs.scrollContainer.scrollLeft = index * cardWidth;
      this.currentIndex = index;
      this.selectContract(
        this.contractList[this.currentIndex],
        this.currentIndex
      );
    },
    async openQrcode() {
      this.openQr = !this.openQr;
      let qr = this.$refs.qrCode;
      if (this.openQr) {
        this.openPayment = false;
        this.$refs.collapsePayment.show = false;

        this.qrButtonLoading = true;
        this.$isLoadingAlpha = true;
        try {
          await this.$refs.qrCode.getPaymentAmount(
            this.contractNo,
            this.currentContract.contractType
          );
        } finally {
          this.qrButtonLoading = false;
          this.$isLoadingAlpha = false;
        }
      }
      this.$refs.collapseQr.show = this.openQr;
      setTimeout(() => {
        if (qr && qr.$el) {
          window.scrollTo({
            top: document.body.clientHeight,
            behavior: "smooth"
          });
        }
      }, 100);
    },
    async handleOpenPayment() {
      this.openPayment = !this.openPayment;
      let onlinePayment = this.$refs.onlinePayment;
      this.$refs.collapsePayment.show = true;
      if (this.openPayment) {
        this.openQr = false;
        this.$refs.collapseQr.show = false;

        this.paymentButtonLoading = true;
        this.$isLoadingAlpha = true;
        try {
          await this.$refs.onlinePayment.getPaymentAmount(
            this.contractNo,
            this.currentContract.contractType
          );
        } finally {
          this.paymentButtonLoading = false;
          this.$isLoadingAlpha = false;
        }
      }
      this.$refs.collapsePayment.show = this.openPayment;

      setTimeout(() => {
        if (onlinePayment && onlinePayment.$el) {
          window.scrollTo({
            top: document.body.clientHeight + 200,
            behavior: "smooth"
          });
        }
      }, 100);
    },
    downloadSKL() {
      window.open("https://www.skl-app.com", "_blank");
    },
    updateTitle() {
      const titles = [
        "SKL Connect - ข้อมูลสัญญา",
        "SKL Connect - ข้อมูลค่างวด",
        "SKL Connect - แฟมิลี่คลับ",
        "SKL Connect - ประวัติการชำระ",
        "SKL Connect - ตารางค่างวด",
        "SKL Connect - ใบแจ้งชำระ",
        "SKL Connect - ใบเสร็จชำระเงิน/ใบกำกับภาษี"
      ];
      const id = Number(this.$route.params.id) || 0;
      document.title = titles[id] || "SKL Connect";
      setTimeout(() => {
        setTimeout(() => {
          const button = this.$refs.tabButton[id];
          if (button) {
            button.scrollIntoView({
              behavior: "smooth",
              block: "nearest"
            });
          }
        }, 100);
      }, 800);
    },

    beforeRouteUpdate(to, from, next) {
      this.updateTitle(); // อัปเดต title เมื่อเส้นทางถูกอัปเดต
      next();
    },

    getReceiptByNoti() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        LineId: this.lineProfile.userId,
        YearCode: this.$route.query.filterYear || "0",
        MonthCode: this.$route.query.filterMonth || "0",
        LogId: this.$route.query.logId || null
      });
      var requestOptions = {
        method: "post",
        headers: myHeaders,
        body: raw
      };
      fetch(
        `${this.$API_DEV_LINE_SKL}/notification/GetReceiptByNoti`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          this.receiptData = result.detail;
        });
    }
  },
  watch: {
    "$route.params.id": {
      handler: "updateTitle"
    },
    currentIndex(newIndex) {
      const contract = this.contractList[newIndex];

      if (
        contract &&
        contract.contractNo !== this.currentContract.contractNo &&
        !this.$route.query.contractNo &&
        !this.$route.query.filterYear
      ) {
        this.selectContract(contract, newIndex, true);
      }
    }
  }
};
</script>

<style scoped>
::v-deep .greenColor thead {
  color: white;
  background-color: rgb(128, 195, 66) !important;
}
.txt-tel {
  text-align: center;
  font-size: 12px;
  bottom: 0;
}
.txt-note {
  font-size: 10px;
}
.link-tel {
  text-decoration-line: none;
  text-align: center;
  /* color: #212529; */
  color: #f48139;
  font-weight: bold;
}
.link-tel-green {
  color: #80c141;
}
.display-inline {
  display: inline-flex;
}
.title-note {
  width: 12%;
}
.content-note {
  width: 88%;
}

::v-deep table > thead > tr > th {
  border: 0.5px solid #cdfca1;
}
::v-deep table > tbody > tr > td {
  border-left: 0.5px solid #cdfca1;
  border-right: 0.5px solid #cdfca1;
}
::v-deep tr:last-child {
  border-bottom: 0.5px solid #cdfca1;
}
@media (max-width: 767.98px) {
  .title-note {
    width: 30%;
  }
  .content-note {
    width: 70%;
  }
  .header-table,
  ::v-deep .table td {
    font-size: 12px;
  }
  ::v-deep .table th {
    padding: 0.5rem;
    font-size: 12px !important;
  }
  /* p {
    font-size: 8px;
  }
  span {
    font-size: 8px;
  } */
}

.insallment-body {
  background-image: url("../../assets/images/installment-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 600px;
  padding-bottom: 100px;
  overflow-y: auto !important;
  width: 100%;
  box-sizing: content-box !important;
  background-color: #f9fbf7;
}

/* @media (max-width: 400px) {
  .insallment-body {
    padding-bottom: 120px !important;
  }
} */

.icon-w {
  width: 20px;
  height: 20px;
}
.bg-body {
  background-color: #f9fbf7 !important;
}

.w-50px {
  width: 50px !important;
}

.submenu-tap {
  overflow-x: auto;
  white-space: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.submenu1-class {
  border-radius: none !important;
  height: 35px !important;
  font-size: 12px !important;
  overflow: hidden;
  text-wrap: nowrap;
  min-width: 150px !important;
}

::v-deep .btn {
  color: #80c141;
}

.img-size {
  width: 100px;
  height: 100px;
}
/* 
.verify-body {
  position: relative;
  height: calc(100vh - 180px - 65px - 80px);
} */

.content-installment {
  box-shadow: rgba(50, 50, 93, 0.25) 2px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  border: 0px;
  min-height: calc(100vh - 180px - 150px - 130px - 150px);
}

.content-tab {
  /* min-height: calc(100vh - 180px - 150px - 130px - 150px); */
  box-shadow: rgba(50, 50, 93, 0.25) 2px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  border: 0px;
}

.content-tab ::v-deep .card-body {
  padding: 1rem;
}

.barcode-card,
.payment-card {
  box-shadow: rgba(50, 50, 93, 0.25) 2px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  border: 0px;
}

.scroll-container {
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 10px;
  scrollbar-width: none !important;
}

.card-slide {
  border: 0cm;
  box-shadow: rgba(50, 50, 93, 0.25) 2px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  flex: 0 0 auto !important;
  /* .scroll-container ตั้ง white-space: nowrap ไว้เพื่อให้การ์ดเรียงแนวนอน
     ได้ ค่านี้ inherit ลงมาโดนข้อความในการ์ดไปด้วย ทำให้ตอนฟอนต์ถูก
     ขยาย (font boosting) หรือซูมหน้าจอ ข้อความยาวเกินการ์ดแล้วไปทับโลโก้/
     การ์ดถัดไปแทนที่จะขึ้นบรรทัดใหม่ ต้อง reset กลับเป็น normal ในนี้ */
  white-space: normal;
}

.indicator-container {
  display: flex;
  gap: 5px;
}

.indicator-dot {
  width: 10px;
  height: 10px;
  background-color: lightgray;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s;
}

.active-dot {
  background-color: #80c141;
}
v-deep .btn-secondary.disabled,
.btn-secondary:disabled {
  color: #fff !important;
  background-color: #6c757d !important;
  border-color: #6c757d !important;
}

.installment-bg {
  background-image: url("../../assets//images/installment-bg.png");
  background-repeat: no-repeat;
  background-size: auto;
}

/* .family-container {
  min-height: 30vh;
  height: 100%;
} */

.f-navy {
  color: navy;
}
</style>
